import styles from './styles.module.css';

export type ProgressBarProps = { value: number; max: number; label: string };

export const ProgressBar = (props: ProgressBarProps) => {
  const { value, max, label } = props;
  const percent = Math.max(0, Math.min(100, (value / max) * 100));

  return (
    <div>
      <div className={styles.progressBarHeader}>
        <strong>{value}</strong>&nbsp; / {max} {label}
      </div>
      <div className={styles.progressBar}>
        <span className={styles.progressBarLabel}>
          {value} {label}
        </span>
        <div className={styles.progressBarFill} style={{ width: `${percent}%` }}></div>
      </div>
    </div>
  );
};
